<template>
	<div>
		<!-- Sales Channels -->
		<div class="p-5 darker">
			<h5>Custom Sales Channel</h5>
			<div class="my-4 initial-height">
				Define your custom sales channels so you can choose them when adding new reservations. For each channel you can define default invoice settings.
			</div>
			<div v-if="getSalesChannels.length < 1" class="text-center dark fs-large w-100">
				No sales channels available
			</div>
			<div>
				<div class="col-sm-6 pl-0">
					<div class="custom-fields">
						<div class="d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover" v-for="salesChannel in getSalesChannels" :key="salesChannel.id">
							<div class="darker bold">{{salesChannel.name}}</div>
							<div class="withHover">
								<span class="lighter bg-dark radius-normal fs-small px-2 pointer" @click="editSalesCHannel(salesChannel)">Edit</span>
								<i v-if="!salesChannel.isImmutable" class="ico ico-delete fs-normal dark pointer ml-2" @click="clickTrash(salesChannel)"></i>
							</div>
						</div>
					</div>
					<button class="btn wide mt-4" @click="AddSalesChannel">Add Sales Channel</button>
				</div>
			</div>
		</div>
		<!-- Origins -->
		<div class="p-5 pt-4 darker">
			<h5>Origins</h5>
			<div class="my-4">
				Define your Origins so you can choose them when adding new reservations.
			</div>
			<div v-if="getOrigins.length < 1" class="text-center dark fs-large w-100">
				No origins available
			</div>
			<div>
				<div class="col-sm-6 pl-0">
					<div v-if="getOrigins.length > 0" class="custom-fields">
						<div class="d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover" v-for="origin in getOrigins" :key="origin.id">
							<div class="darker bold">{{origin.name}}</div>
							<div class="withHover">
								<span class="lighter bg-dark radius-normal fs-small px-2 pointer" @click="editOrigin(origin)">Edit</span>
								<i class="ico ico-delete fs-normal dark pointer ml-2" @click="clickTrashOrigin(origin)"></i>
							</div>
						</div>
					</div>
					<button class="btn wide mt-4" @click="AddOrigin">Add Origin</button>
				</div>
			</div>
		</div>
		<!-- Segments -->
		<div class="p-5 pt-4 darker">
			<h5>Segments</h5>
			<div class="my-4">
				Define your Segments so you can choose them when adding new reservations.
			</div>
			<div v-if="getSegments.length < 1" class="text-center dark fs-large w-100">
				No segments available
			</div>
			<div>
				<div class="col-sm-6 pl-0">
					<div v-if="getSegments.length > 0" class="custom-fields">
						<div class="d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover" v-for="segment in getSegments" :key="segment.id">
							<div class="darker bold">{{segment.name}}</div>
							<div class="withHover">
								<span class="lighter bg-dark radius-normal fs-small px-2 pointer" @click="editSegment(segment)">Edit</span>
								<i class="ico ico-delete fs-normal dark pointer ml-2" @click="clickTrashSegment(segment)"></i>
							</div>
						</div>
					</div>
					<button class="btn wide mt-4" @click="AddSegment">Add Segment</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'
    import List from '@/tools/list/baseList'

    export default {
        data: function() {
            return {
            }
        },
        props:[
            'presets'
        ],
        computed:{
            ...mapGetters([
                'getSalesChannels',
				'getOrigins',
				'getSegments',
            ])
        },
        methods:{
            ...mapActions([
                'saveSettingsPresets',
                'setSelectedSalesChannel',
                'deleteSalesChannel',
                'openModal',
				'setSelectedOrigin',
				'setSelectedSegment',
				'deleteOrigin',
				'deleteSegment',
            ]),
			AddOrigin: function() {
				this.openModal('origins/createOrigin')
			},
			AddSegment: function() {
				this.openModal('segments/createSegment')
			},
            AddSalesChannel: function() {
                this.openModal('salesChannels/createSalesChannel')
            },
            editSalesCHannel: function(salesChannel) {
                this.setSelectedSalesChannel(salesChannel)
                this.openModal('salesChannels/editSalesChannel')
            },
            editOrigin: function(origin) {
                this.setSelectedOrigin(origin)
                this.openModal('origins/editOrigin')
            },
            editSegment: function(segment) {
                this.setSelectedSegment(segment)
                this.openModal('segments/editSegment')
            },
            clickTrash: function(salesChannel) {
                let vm = this

                this.$dialog.confirm('\
                <div class="fs-larg font-weight-600 mb-4">Delte sales channel?</div>\
                <div>Your are about to delete the sales channel "'+salesChannel.name+'", continue?</span></div>')
                .then(function () {
                    vm.deleteSalesChannel(salesChannel)
                })
                .catch(function () {
                    // pressed No
                });
            },
			clickTrashOrigin: function(origin) {
				let vm = this

				this.$dialog.confirm('\
					<div class="fs-larg font-weight-600 mb-4">Delte origin?</div>\
					<div>Your are about to delete the origin "'+origin.name+'", continue?</span></div>'
				).then(function () {
					vm.deleteOrigin(origin)
				}).catch(function (error) {
					console.error(error)
				})
			},
			clickTrashSegment: function(segment) {
				let vm = this

				this.$dialog.confirm('\
					<div class="fs-larg font-weight-600 mb-4">Delte segment?</div>\
					<div>Your are about to delete the segment "'+segment.name+'", continue?</span></div>'
				).then(function () {
					vm.deleteSegment(segment)
				}).catch(function (error) {
					console.error(error)
				})
			}
        },
        components:{
            vSelect: extendedVSelect,
            List
        }
    }
</script>

<style lang="scss" scoped>
    .custom-fields {
        overflow: auto;
        max-height: 24.5rem;
    }

	.initial-height {
        min-height: 2.5rem;
    }
</style>



// WEBPACK FOOTER //
// TabSalesChannels.vue?619fa1f6